export class WebApiResponse<T>
{
	message: string;
	success: boolean;
	data: T;
}